import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import linkifyHtml from 'linkify-html'
import sanitizeHtml from 'sanitize-html'

const Message = ({index, player, onShowPlayer, admin, message, imageUrl, onDelete}) => {
  const [showDelete, setShowDelete] = useState(false)

  const messageContent = () => {
    if(message.type == 'text') {
      return (
        <div className='text' dangerouslySetInnerHTML={
          {__html: sanitizeHtml(linkifyHtml(message.payload.text, {defaultProtocol: 'https', target: '_blank'}))}
        } />
      )
    } else if(message.type == 'gif') {
      return (
        <img className='media' src={`https://media.giphy.com/media/${message.payload.id}/giphy.gif`}></img>
      )
    } else if(message.type == 'image') {
      return (
        <img className='media' src={message.payload.url}></img>
      )
    }
  }

  return (
    <div className={classNames('message', { 'admin': admin })}
      onMouseEnter={() => setShowDelete(true)}
      onMouseLeave={() => setShowDelete(false)}>
      <div className='avatar' onClick={() => onShowPlayer(player.id)}>
        <img className='avatar-image' src={imageUrl} />
      </div>
      <div className='message__content'>
        <div className='player'>{player.name}</div>
        {messageContent()}
      </div>
      { index != 0 && showDelete &&
        <div className='delete btn btn-danger' onClick={onDelete}><i className='fa fa-trash-o'></i></div>
      }
    </div>
  )
}

Message.propTypes = {
  index: PropTypes.number,
  admin: PropTypes.bool,
  player: PropTypes.object,
  imageUrl: PropTypes.string,
  message: PropTypes.object,
  onDelete: PropTypes.func
}

export default Message
